"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReCaptchaInstance = exports.getInstance = exports.load = void 0;
var ReCaptchaLoader_1 = require("./ReCaptchaLoader");
Object.defineProperty(exports, "load", { enumerable: true, get: function () { return ReCaptchaLoader_1.load; } });
Object.defineProperty(exports, "getInstance", { enumerable: true, get: function () { return ReCaptchaLoader_1.getInstance; } });
var ReCaptchaInstance_1 = require("./ReCaptchaInstance");
Object.defineProperty(exports, "ReCaptchaInstance", { enumerable: true, get: function () { return ReCaptchaInstance_1.ReCaptchaInstance; } });



//////////////////
// WEBPACK FOOTER
// ./~/recaptcha-v3/dist/ReCaptcha.js
// module id = 151
// module chunks = 2